import { r as rjPlugin, g as get } from '../../rjPlugin.es.js';
import { set } from 'object-path-immutable';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toArray';
import 'rxjs';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/defineProperty';
import 'rxjs/operators';

var TYPE = 'RJ_LIST_UPDATE';

var defaultIdentity = function defaultIdentity(action, listItem) {
  return action.item.id === listItem.id;
};

var defaultUpdater = function defaultUpdater(action) {
  return action.item;
};

var rjListUpdate = function rjListUpdate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var identity = config.identity || defaultIdentity;
  var updater = config.updater || defaultUpdater;
  var path = config.path || 'data';
  return rjPlugin({
    actions: function actions() {
      return {
        updateItem: function updateItem(item) {
          return {
            type: TYPE,
            item: item
          };
        }
      };
    },
    reducer: function reducer(oldReducer) {
      return function (state, action) {
        if (action.type === TYPE) {
          var list = get(state, path);
          if (list) list = list.map(function (listItem) {
            return identity(action, listItem) ? updater(action, listItem) : listItem;
          });
          return set(state, path, list);
        }

        return oldReducer(state, action);
      };
    }
  });
};

export default rjListUpdate;
export { TYPE };
